import { Link, useParams } from 'react-router-dom'
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
//import dayjs from 'dayjs'
import DashboardWrapper from '../Dashboard/components/DashboardWrapper'
import Loader from '../../components/Loader'
import Toast from '../../components/Toast/Toast'
import { ContractDocumentViewer } from '../../components/ContractDocumentViewer/ContractDocumentViewer'
import { PRIVATE_ROUTES } from '../../Routes/routes'
import {
  acceptCompanyInvoice,
  getCompanyInvoiceById,
} from '../../services/NewServicesCompnay'
import { TAGS } from '../../services/Tags'
import { INVOICE_STATUS_ID } from '../../utils/invoiceStatus'

//const ACCENT = '#7c3aed'

const cardStyle = {
  background: '#fff',
  borderRadius: 12,
  border: '1px solid #e5e7eb',
  boxShadow: '0 1px 3px rgba(0, 0, 0, 0.04)',
}

// const infoGridStyle = {
//   display: 'grid',
//   gridTemplateColumns: 'repeat(auto-fill, minmax(200px, 1fr))',
//   gap: 16,
// }

// const fmtMoney = (value, currency = 'EUR') => {
//   const num = Number(value)
//   if (Number.isNaN(num)) return '—'
//   return new Intl.NumberFormat('es-ES', { style: 'currency', currency }).format(num)
// }

//const fmtDate = (value) => (value ? dayjs(value).format('DD/MM/YYYY') : '—')

const getDetailTitle = (statusId) =>
  Number(statusId) === INVOICE_STATUS_ID.PAGADA
    ? 'Detalle de la factura'
    : 'Detalle de la factura proforma'

// const InfoField = ({ label, value, highlight }) => (
//   <div
//     style={{
//       padding: '18px 20px',
//       background: highlight ? '#f5f3ff' : '#f9fafb',
//       borderRadius: 10,
//       border: highlight ? '1px solid #ddd6fe' : '1px solid #f3f4f6',
//     }}
//   >
//     <div
//       style={{
//         fontSize: 11,
//         color: '#6b7280',
//         marginBottom: 8,
//         textTransform: 'uppercase',
//         letterSpacing: '0.05em',
//         fontWeight: 600,
//       }}
//     >
//       {label}
//     </div>
//     <div
//       style={{
//         fontSize: highlight ? 20 : 15,
//         color: highlight ? ACCENT : '#111827',
//         fontWeight: 700,
//         lineHeight: 1.3,
//         wordBreak: 'break-word',
//       }}
//     >
//       {value}
//     </div>
//   </div>
// )

const CompanyInvoiceDetail = () => {
  const { id } = useParams()
  const queryClient = useQueryClient()

  const { data: invoice, isLoading, isError } = useQuery(
    [TAGS.company_invoice_detail, id],
    () => getCompanyInvoiceById(id),
    {
      enabled: Boolean(id),
      select: (data) => data?.res?.invoice ?? null,
    }
  )

  const { mutate: acceptInvoice, isLoading: isAccepting } = useMutation(
    acceptCompanyInvoice,
    {
      onSuccess: ({ response, res }) => {
        if (!response?.ok) {
          Toast({
            icon: 'error',
            title: res?.msg || res?.error || 'No se pudo aceptar la factura',
          })
          return
        }

        queryClient.invalidateQueries([TAGS.company_invoice_detail, id])
        Toast({ title: 'Factura aceptada correctamente' })
      },
      onError: () => {
        Toast({ icon: 'error', title: 'No se pudo aceptar la factura' })
      },
    }
  )

  const title = getDetailTitle(invoice?.invoice_status?.id)
  const isProforma =
    Number(invoice?.invoice_status?.id) !== INVOICE_STATUS_ID.PAGADA
  const canAccept = Boolean(invoice) && isProforma && !invoice.accept
  // const currency = invoice?.coin?.short_name || 'EUR'
  // const description = invoice?.description || invoice?.descriptrion || '—'

  return (
    <DashboardWrapper dashboardWrapperClassName="w-100 flex-grow-1">
      <div className="p-3 pt-lg-5 mt-lg-4 w-100" style={{ maxWidth: 1100, margin: '0 auto' }}>
        {isLoading ? (
          <div className="d-flex justify-content-center py-5">
            <Loader />
          </div>
        ) : isError || !invoice ? (
          <div className="bg-white rounded border p-4" style={{ borderColor: '#e5e7eb' }}>
            <p className="text-on-bg-secondary mb-2">No se encontró la factura.</p>
            <Link to={PRIVATE_ROUTES.company_billing}>Volver al historial</Link>
          </div>
        ) : (
          <>
            {/* <div className="d-flex flex-wrap align-items-center justify-content-between gap-2 mb-4">
              <h2 className="text-bg-brand mb-0" style={{ fontWeight: 800, fontSize: 22 }}>
                {title}
              </h2>
              <div className="d-flex align-items-center gap-2 flex-wrap">
                {invoice.invoice_status?.name && (
                  <span
                    className="rounded-pill px-3 py-1"
                    style={{ background: '#f5f3ff', color: ACCENT, fontSize: 12, fontWeight: 700 }}
                  >
                    {invoice.invoice_status.name}
                  </span>
                )}
                {invoice.invoice_url && (
                  <a
                    href={invoice.invoice_url}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="btn btn-sm btn-outline-primary"
                  >
                    Descargar factura
                  </a>
                )}
              </div>
            </div> */}

            {/* <div style={{ ...cardStyle, padding: '24px 28px' }} className="mb-4">
              <div style={infoGridStyle}>
                <InfoField label="Número" value={invoice.title || '—'} />
                <InfoField label="Fecha de emisión" value={fmtDate(invoice.issue_date || invoice.created_at)} />
                <InfoField label="Vencimiento" value={fmtDate(invoice.due_date)} />
                <InfoField label="Subtotal" value={fmtMoney(invoice.subtotal, currency)} />
                <InfoField label="Impuestos" value={fmtMoney(invoice.tax_amount, currency)} />
                <InfoField label="Total" value={fmtMoney(invoice.total_amount, currency)} highlight />
              </div>

              <div className="mt-4">
                <div
                  style={{
                    fontSize: 11,
                    color: '#6b7280',
                    marginBottom: 8,
                    textTransform: 'uppercase',
                    letterSpacing: '0.05em',
                    fontWeight: 600,
                  }}
                >
                  Descripción
                </div>
                <p className="mb-0" style={{ fontSize: 14, color: '#374151', lineHeight: 1.5 }}>
                  {description}
                </p>
              </div>
            </div> */}

            <div style={{ ...cardStyle, padding: '20px 24px' }}>
              <div className="d-flex flex-wrap align-items-center justify-content-between gap-2 mb-3">
                <p className="mb-0" style={{ fontWeight: 700, fontSize: 16, color: '#111827' }}>
                  {title}
                </p>
                {canAccept && (
                  <button
                    type="button"
                    className="btn btn-bg-CTA-primary text-on-bg-primary"
                    style={{ borderRadius: 8 }}
                    onClick={() => acceptInvoice({ id, status: true })}
                    disabled={isAccepting}
                  >
                    {isAccepting ? <Loader /> : 'Aceptar factura proforma'}
                  </button>
                )}
              </div>
              <ContractDocumentViewer finalPdfUrl={invoice.invoice_url || null} previewLabel="factura" />
            </div>
          </>
        )}
      </div>
    </DashboardWrapper>
  )
}

export default CompanyInvoiceDetail
